import { createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";

type Parameter = {
    savedCartName: string;
} & HasOnSuccess<true>;

type Props = {
    apiResult: true;
};

type HandlerType = Handler<Parameter, Props>;

export const SetSavedOrderName: HandlerType = props => {
    props.dispatch({
        type: "Custom/SavedOrderState/UpdateSavedOrderName",
        savedCartName: props.parameter.savedCartName,
    } as any);
};

export const chain = [SetSavedOrderName];

const setSavedOrderName = createHandlerChainRunner(chain, "SetSavedOrderName");
export default setSavedOrderName;
